// extracted by mini-css-extract-plugin
export var copyIcon = "_s6-2";
export var discountCard = "_s6-0";
export var discountCode = "_s6-3";
export var discountContent = "_s6-1";
export var loadingCard = "_s6-4";